import { toNote } from '@/lib/link'
import { tagNameEquals } from '@/lib/tag'
import { cn } from '@/lib/utils'
import { Event } from '@nostr/tools/wasm'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import Content from './Content'

export default function GeocacheFoundLogPreview({
  event,
  className
}: {
  event: Event
  className?: string
}) {
  const { t } = useTranslation()
  const verified = useMemo(() => event.tags.some(tagNameEquals('verification')), [event])

  return (
    <div className={cn('pointer-events-none', className)}>
      [{verified ? t('Verified found log') : t('Found log')}]{' '}
      <a href={toNote(event)} onClick={(e) => e.preventDefault()}>
        <Content event={event} className="italic pr-0.5" />
      </a>
    </div>
  )
}
